

































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Services ---
import AppService from '@/services/app';
import DashboardService from '@/services/dashboard';
import ResultService from '@/services/result';

// --- Models ---
import { Career, CareerSubject } from '@/models/Career.model';
import { Result } from '@/models/Result.model';

@Component
export default class Results extends Vue {
  
  isLoading: boolean = false;
  valid: boolean = false;
  clicked: boolean = false;

  // we only use R1, R2 and P1 from the result stored proc - fetched the rest encase we needed them for the results pdf
  clickedItem: Result = {
    result1: '',
    result2: '',
    personality: '',
    result1Description: '',
    result2Description: '',
    personalityDescription: '',
  };

  emptyCareer: Career = {
    id: 0,
    jobTitle: '',
    classification: '',
    description: '',
    disabled: false,
    hasRequiredSubjects: true,
  };

  allCareers: Career[] = [];
  myPrimaryCareers: Career[] = [];
  mySecondaryCareers: Career[] = [];
  career1: Career =  Object.assign({}, this.emptyCareer);
  career2: Career =  Object.assign({}, this.emptyCareer);
  career3: Career =  Object.assign({}, this.emptyCareer);  
  additionalCareer: Career =  Object.assign({}, this.emptyCareer);

  rules = {
    careerRequired: (value: Career) => value.id > 0 || '',
  };

  // variables for career info dialog
  showInformationDialog: boolean = false;
  clickedCareer: Career = {
    id: 0,
    jobTitle: '',
    classification: '',
    description: '',
    disabled: false,
    hasRequiredSubjects: true,
  };
  qualifications: string[] = [];
  subjects: CareerSubject[] = [];

  // region Functions to display data on page load

    async beforeMount() {
      await this.getResult();

      // fetch all careers, required for drop-down 4
      await AppService.getCareers(false);
      // now create a copy because we are going to be changing disabled and don't want to affect the store
      this.allCareers = Array.from(this.$store.getters['app/careers']);

      // now fetch the relevant careers for this user's results
      // as per Sean's stored proc, the first & second drop-down use the results it their primary order
      this.myPrimaryCareers = this.allCareers.filter((value) => 
        value.classification.includes(this.clickedItem.result1.substring(0, 1) + this.clickedItem.result2.substring(0, 1)));
      // the third drop-down shows careers by switching their results around 
      this.mySecondaryCareers = this.allCareers.filter((value) => 
        value.classification.includes(this.clickedItem.result2.substring(0, 1) + this.clickedItem.result1.substring(0, 1)));

      this.disableCareer(this.emptyCareer);
    }

    async getResult() {
      try {
        this.isLoading = true;
        const response = await ResultService.getResult();

        if (response && response.data) {
          if (response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            this.clickedItem = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }
        
      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      } finally {
        this.isLoading = false;
      }
    }
  // #endregion

  async showCareer(career: Career) {
    this.clickedCareer = career;

    if (this.clickedCareer.qualifications) {
      this.qualifications = this.clickedCareer.qualifications.split(',');
    }

    await this.getSubjectsByCareer();

    this.showInformationDialog = true;
  }

  async getSubjectsByCareer() {
    this.subjects = [];
    
    try {
      const response = await DashboardService.getSubjectsByCareer({ params: { careerId: this.clickedCareer.id }});

      if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            // do nothing, there are no subjects for this career            
          } else {
             this.subjects = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }
    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }
    }
  }

  disableCareer(career: Career) {
    // switch on all careers, switch off for selected ones
    this.allCareers.forEach((career: Career) => {
      if (career.id === this.career1.id || career.id === this.career2.id || career.id === this.career3.id || career.id === this.additionalCareer.id) {
        // disable
        career.disabled = true;
      } else {
        // enable
        career.disabled = false;
      }
    });

    // repeat for my careers
    this.myPrimaryCareers.forEach((career: Career) => {
      if (career.id === this.career1.id || career.id === this.career2.id || career.id === this.career3.id || career.id === this.additionalCareer.id) {
        // disable
        career.disabled = true;
      } else {
        // enable
        career.disabled = false;
      }
    });

    this.mySecondaryCareers.forEach((career: Career) => {
      if (career.id === this.career1.id || career.id === this.career2.id || career.id === this.career3.id || career.id === this.additionalCareer.id) {
        // disable
        career.disabled = true;
      } else {
        // enable
        career.disabled = false;
      }
    });

  }

  async saveResult() {
    this.clicked = true;

    try {
      const response = await ResultService.resultCreate({ result1: this.clickedItem.result1, result2: this.clickedItem.result2, 
        personality: this.clickedItem.personality, career1: this.career1.id, career2: this.career2.id, career3: this.career3.id,
        additionalCareer: this.additionalCareer.id });

      if (response && response.data) {
        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          this.$router.push( { name: 'Generating Report PDF' } );
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
    }
  }

}
